/* eslint-disable react/forbid-dom-props */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './../spzaComponent';
import { NpsModule } from './../../utils/npsUtils';
import { Constants } from './../../utils/constants';
import { getWindow } from '../../services/window';
import { isEmailValid } from './../../utils/appUtils';
import { storeFeedback } from '@shared/services/feedback';
import { logger } from '@src/logger';
import classNames from 'classnames';
class NpsModal extends SpzaComponent {
    editDescription(e) {
        this.description = e.target ? e.target.value : '';
        this.setState({
            description: this.description,
            privacy: this.state.privacy,
            validEmailUI: this.state.validEmailUI,
            emailAddress: this.state.emailAddress
        });
    }
    handleRatingChange(ratingNumber) {
        this.setState({
            rating: ratingNumber,
            description: this.description,
            privacy: this.state.privacy,
            validEmailUI: this.state.validEmailUI,
            emailAddress: this.state.emailAddress
        });
    }
    decline() {
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.NPS,
            actionModifier: Constants.Telemetry.ActionModifier.Declined,
            details: ''
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
        NpsModule.Declined();
        this.props.dismissModal();
    }
    handleSubmit() {
        if (!this.state.rating || this.state.privacy && !this.state.validEmailUI) {
            return this.decline();
        }
        const npsResult = {
            rating: this.state.rating,
            description: this.state.description,
            email: this.state.privacy ? this.state.emailAddress : ''
        };
        storeFeedback({
            action: Constants.Telemetry.Action.NPS,
            actionModifier: Constants.Telemetry.ActionModifier.Info,
            details: JSON.stringify(npsResult)
        });
        NpsModule.Submitted();
        this.props.dismissModal();
    }
    onChangePrivacy() {
        this.setState({
            privacy: !this.state.privacy,
            validEmailUI: this.state.validEmailUI,
            emailAddress: this.state.emailAddress
        });
    }
    editEmail(e) {
        this.setState({
            privacy: this.state.privacy,
            validEmailUI: this.state.validEmailUI,
            emailAddress: e.target ? e.target.value : ''
        });
        if (this.state.privacy) {
            if (isEmailValid(this.state.emailAddress)) {
                this.setState({
                    privacy: this.state.privacy,
                    validEmailUI: true,
                    emailAddress: e.target ? e.target.value : ''
                });
            } else {
                this.setState({
                    privacy: this.state.privacy,
                    validEmailUI: false,
                    emailAddress: e.target ? e.target.value : ''
                });
            }
        }
    }
    handleNumberBtnKeyPress(evt, value) {
        evt = evt || window.event;
        // only the enter key can toggle the user profile button to show/hide dropdown menu
        if (evt.charCode === Constants.SystemKey.Enter) {
            this.handleRatingChange(value, evt);
        }
        evt.preventDefault();
    }
    ratingPane(self) {
        const paneContent = [];
        const arr = [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10'
        ];
        // eslint-disable-next-line array-callback-return
        arr.map((value)=>{
            const classes = classNames({
                ratingSelected: self.state.rating === value,
                ratingBlock: true,
                ratingTen: value === '10'
            });
            if (value === '0') {
                paneContent.push(/*#__PURE__*/ _jsx("li", {
                    className: classes,
                    value: value.toString(),
                    tabIndex: 0,
                    onClick: ()=>this.handleRatingChange.bind(this)(value),
                    onKeyPress: (event)=>{
                        this.handleNumberBtnKeyPress(event, value);
                    },
                    children: /*#__PURE__*/ _jsx("a", {
                        className: "ratingNumber",
                        children: value
                    })
                }));
            } else {
                paneContent.push(/*#__PURE__*/ _jsx("li", {
                    className: classes,
                    value: value.toString(),
                    tabIndex: 0,
                    onClick: ()=>this.handleRatingChange.bind(this)(value),
                    onKeyPress: (event)=>{
                        this.handleNumberBtnKeyPress(event, value);
                    },
                    children: /*#__PURE__*/ _jsx("a", {
                        className: "ratingNumber",
                        children: value
                    })
                }));
            }
        });
        return paneContent;
    }
    renderImpl() {
        const emailInputClasses = classNames({
            'c-text-field': true,
            npsEmailInput: true,
            invalidEmailInput: this.state.privacy && !this.state.validEmailUI
        });
        return /*#__PURE__*/ _jsx("div", {
            role: "dialog",
            "aria-label": "nps is now open, tell us what you think",
            className: "npsModalClass",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "prompContainer",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "toolBar",
                        children: /*#__PURE__*/ _jsx("button", {
                            id: "cancelButton",
                            "aria-label": "close",
                            className: "cancel",
                            onClick: this.decline.bind(this),
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "c-glyph"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "npsModal",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "contentHeader",
                                children: this.context.loc('Feedback_Header')
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "rateHeader",
                                children: this.context.loc('NPS_RatingQuestion')
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "rateSlider",
                                children: [
                                    /*#__PURE__*/ _jsx("ul", {
                                        className: "ratingControl",
                                        children: this.ratingPane(this)
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "ratingLabel",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "ratingLeftLabel",
                                                children: this.context.loc('NPS_NotLikely', 'Not at all likely')
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "ratingRightLabel",
                                                children: this.context.loc('NPS_Likely', 'Very likely')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "rateReasonInput",
                                children: /*#__PURE__*/ _jsx("textarea", {
                                    id: "subscription",
                                    className: "c-text-field f-flex npsTextArea",
                                    onChange: this.editDescription.bind(this),
                                    value: this.description,
                                    autoFocus: true,
                                    placeholder: `${this.context.loc('NPS_RatingReasonQuestion', 'Tell us more about your experience')}.\n${this.context.loc('Specific_app_feedback')}`,
                                    name: "default"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "c-checkbox npsPrivacy",
                                children: /*#__PURE__*/ _jsxs("label", {
                                    className: "c-label privacyHeader",
                                    children: [
                                        /*#__PURE__*/ _jsx("input", {
                                            "aria-label": "Control label (unselected)",
                                            type: "checkbox",
                                            id: "checkboxId1",
                                            name: "checkboxId1",
                                            value: "value1",
                                            "aria-checked": "false",
                                            checked: this.state.privacy,
                                            onChange: this.onChangePrivacy.bind(this)
                                        }),
                                        /*#__PURE__*/ _jsxs("span", {
                                            "aria-hidden": "true",
                                            children: [
                                                this.context.loc('Feedback_privacy_content'),
                                                /*#__PURE__*/ _jsx("a", {
                                                    target: "_blank",
                                                    href: "https://aka.ms/AppSourcePrivacyStatement",
                                                    rel: "noreferrer",
                                                    className: "c-hyperlink",
                                                    children: this.context.loc('Feedback_privacy')
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("input", {
                                className: emailInputClasses,
                                type: "text",
                                onChange: this.editEmail.bind(this),
                                value: this.state.emailAddress,
                                placeholder: this.props.emailAddress === 'no user' ? 'email address' : '',
                                name: "default",
                                disabled: !this.state.privacy
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "npsButton",
                                children: [
                                    !this.state.privacy || this.state.privacy && this.state.validEmailUI ? null : /*#__PURE__*/ _jsx("span", {
                                        className: "invalidEmailText",
                                        children: this.context.loc('Feedback_invalidEmail')
                                    }),
                                    /*#__PURE__*/ _jsx("button", {
                                        id: "submit",
                                        name: "button",
                                        disabled: this.state.privacy && !this.state.validEmailUI || this.state.rating === null,
                                        className: "c-button submitButton",
                                        type: "submit",
                                        onClick: this.handleSubmit.bind(this),
                                        children: this.context.loc('NPS_SubmitButton', 'Submit')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "description", void 0);
        // if this poped-up, the timer is automatically delay a short
        // interval (two-hours).
        NpsModule.SetShortInterval();
        NpsModule.ResetNPSCount();
        this.description = '';
        this.state = {
            rating: null,
            description: '',
            privacy: false,
            validEmailUI: true,
            emailAddress: this.props.emailAddress !== 'no user' ? this.props.emailAddress : ''
        };
    }
}
export { NpsModal as default };
NpsModal.contextTypes = {
    loc: PropTypes.func,
    renderErrorModal: PropTypes.func
};
